/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import AssetModel from 'cio/models/asset';

interface AssetLibraryItemCheckboxArgs {
  asset: AssetModel;
  isChecked: boolean;
  onCheck: (checked: boolean, asset: AssetModel) => unknown;
  size?: 'lg' | 'xl';
}

export default class AssetLibraryItemCheckbox extends Component<AssetLibraryItemCheckboxArgs> {
  get size() {
    return this.args.size ?? '';
  }

  @action
  onCheck(checked: boolean) {
    this.args.onCheck(checked, this.args.asset);
  }

  @action
  onInterceptCheckboxClick(e: MouseEvent) {
    // this empty handler is needed to intercept the click event before @onSelect
    e.stopPropagation();
  }
}
